import { render, staticRenderFns } from "./dyClueRelationship.vue?vue&type=template&id=f4cc1836"
import script from "./dyClueRelationship.vue?vue&type=script&lang=js"
export * from "./dyClueRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports